<template>
  <section class="p-storagemonitor">
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="monitor-wrap">
        <section class="c-mt-84 monitor-title">
          <p class="c-fs-32 c-mb c-fw-b c-c-text-color-dark">存储监控系统</p>
          <p class="c-fs-16 c-mt-36 c-mb-56 c-lh-38 c-ta-j">来自 MonitorWay 存储监控系统和容量管理软件可以为您提供对多厂商的存储阵列性能的深度可见性，
            并帮助您密切关注应用程序堆栈中是否存在的影响应用程序性能的存储问题。</p>
          <img src="../../assets/monitor/storage.jpg" class="c-cs-p" preview="monitor-storage"/>
        </section>
        <section>
          <div class="c-d-f c-ai-c c-mt-84">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">MonitorWay 存储监控系统概览</span>
          </div>
          <div class="c-bc-white c-fs-14 c-c-text-grey c-lh-36 c-mt-40 c-pt-56 c-pl-92 c-pb-128 c-p-r">
            <ul>
              <li>支持多厂商的存储设备的统一监控管理。</li>
              <li>实现存储容量规划和报告的收集和展示自动化。</li>
              <li>回收存储空间并简化存储使用情况分析。</li>
              <li>只需约 1 小时即可开始监控您的存储基础设施。</li>
            </ul>
            <img src="../../assets/monitor/storage-pic.png" class="c-pr-40 pic">
          </div>
        </section>
        <section class="c-pb-164 features">
          <div class="c-d-f c-ai-c c-mt-80">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">功能介绍</span>
          </div>
          <div class="c-d-f c-jc-sb c-fw-w c-mt-40 features-wrap">
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item features-special">
              <img src="../../assets/monitor/internet7.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">存储性能监控</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">获得存储环境性能和状态的统一视图。使用MonitorWay存储监控系统进行实时的无代理 NAS和 SAN 性能监控，
                  以及监控卷、RAID 组、存储池、磁盘等的数据。这有助于实现您的存储网络始终以高性能运行，同时防止停机。快速、轻松配置完整的自定义和预定义警报。
                </p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item features-special">
              <img src="../../assets/monitor/internet9.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">自动存储容量规划</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">存储容量规划是一项艰巨任务，特别是在虚拟基础设施中。它通常会涉及到手动创建复杂的电子表格。
                  MonitorWay存储监控系统可实现预测数据收集自动化，使您可以轻松查看增长率、预测成本和预算要求，并预计容量占满的时间。除了简化存储容量规划之外，
                  SRM 还提供可帮助您避免因磁盘装满错误而导致运行中断所需的信息。集中监控功能可以长期跟踪性能，以确定热点、高峰时段和潜在运行中断。
                </p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item features-special">
              <img src="../../assets/monitor/virtual2.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">存储 LUN 视图</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">存储 LUN 视图可以为您提供 LUN 和所有相关基础设施组件（物理组件和虚拟组件）的单一管理界面，从而使您可以诊断性能问题。
                  您可以快速确定虚拟机性能不佳的真正原因是否为存储问题。如确定罪魁祸首为其他虚拟机或 LUN，则您可以在工具内深入调查并继续诊断问题。
                </p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item features-special">
              <img src="../../assets/monitor/storage4.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">存储 I/O 热点检测</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">MonitorWay存储监控系统中的存储 I/O 热点检测功能可以扫描多供应商存储环境、确定潜在问题，
                  并让您能够快速访问造成问题的物理和虚拟资源的详细信息。
                </p>
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="cm-width monitor-wrap-mobile">
        <section class="c-mt-40 monitor-title">
          <p class="c-fs-19 c-fw-b c-c-text-color-dark">存储监控系统</p>
          <p class="c-fs-12 c-mt-16 c-mb-24 c-lh-22 c-ta-j">来自 MonitorWay存储监控系统和容量管理软件可以为您提供对多厂商的存储阵列性能的深度可见性，
            并帮助您密切关注应用程序堆栈中是否存在的影响应用程序性能的存储问题。</p>
          <img src="../../assets/monitor/storage.jpg" preview="monitor-storage1"/>
        </section>
        <section>
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">MonitorWay 存储监控系统概览</span>
          </div>
          <div class="c-bc-white c-fs-13 c-c-text-grey c-lh-28 c-mt-24 c-ptb-20 c-pl-36 c-pr-16 c-boxshadow">
            <ul>
              <li>支持多厂商的存储设备的统一监控管理。</li>
              <li>实现存储容量规划和报告的收集和展示自动化。</li>
              <li>回收存储空间并简化存储使用情况分析。</li>
              <li>只需约 1 小时即可开始监控您的存储基础设施。</li>
            </ul>
          </div>
        </section>
        <section class="features">
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">功能介绍</span>
          </div>
          <div class="c-mt-24 features-wrap">
            <div class="c-mb-8 features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/internet7.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">存储性能监控</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">获得存储环境性能和状态的统一视图。使用MonitorWay存储监控系统进行实时的无代理 NAS和 SAN 性能监控，
                    以及监控卷、RAID 组、存储池、磁盘等的数据。这有助于实现您的存储网络始终以高性能运行，同时防止停机。快速、轻松配置完整的自定义和预定义警报。</p>
                </div>
              </div>
            </div>
            <div class="c-mb-8 features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/internet9.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">自动存储容量规划</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">存储容量规划是一项艰巨任务，特别是在虚拟基础设施中。它通常会涉及到手动创建复杂的电子表格。
                    MonitorWay存储监控系统可实现预测数据收集自动化，使您可以轻松查看增长率、预测成本和预算要求，并预计容量占满的时间。除了简化存储容量规划之外，
                    SRM 还提供可帮助您避免因磁盘装满错误而导致运行中断所需的信息。集中监控功能可以长期跟踪性能，以确定热点、高峰时段和潜在运行中断。</p>
                </div>
              </div>
            </div>
            <div class="c-mb-8 features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/virtual2.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">存储 LUN 视图</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">存储 LUN 视图可以为您提供 LUN 和所有相关基础设施组件（物理组件和虚拟组件）的单一管理界面，从而使您可以诊断性能问题。
                    您可以快速确定虚拟机性能不佳的真正原因是否为存储问题。如确定罪魁祸首为其他虚拟机或 LUN，则您可以在工具内深入调查并继续诊断问题。</p>
                </div>
              </div>
            </div>
            <div class="c-mb-32 features-item">
              <div class="c-bc-white c-d-f c-pe-none">
                <img src="../../assets/monitor/storage4.png">
                <div class="c-ml-24">
                  <p class="c-fs-15 c-c-text-blue c-mb-8">存储 I/O 热点检测</p>
                  <p class="c-fs-12 c-lh-20 c-c-text-grey">MonitorWay存储监控系统中的存储 I/O 热点检测功能可以扫描多供应商存储环境、确定潜在问题，
                    并让您能够快速访问造成问题的物理和虚拟资源的详细信息。</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
export default {
  name: 'storage',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
.p-storagemonitor {
  @media screen and (min-width: 1180px) {
    min-height: calc(100vh - 90px - 525px);
    background: url('../../assets/monitor/monitor-bg.png') no-repeat;
    background-position: bottom;
    background-size: 100%;
  }
  .monitor-wrap {
    width: 1180px;
    margin: 0 auto;
    .monitor-title {
      img {
        height: 417px;
      }
    }
    .pic {
      position: absolute;
      right: 0;
      top: -90px;
    }
    .features {
      .features-wrap {
        .features-item {
          width: calc(50% - 7px);
          padding: 44px 54px;
          margin-bottom: 14px;
          box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
          border-radius: 1px;
          img {
            width: 18%;
          }
        }
        .features-special {
          width: 100%;
          img {
            width: 10%;
          }
        }
      }
    }
  }
  .monitor-wrap-mobile {
    .monitor-title {
      img {
        // height: 202px;
        width: 100%;
      }
    }
    .features {
      .features-wrap {
        padding-bottom: 25px;
        .features-item {
          width: 100%;
          padding: 25px 16px;
          background: white;
          text-align: justify;
          img {
            width: 38px;
            height: 38px;
            object-fit: contain;
          }
        }
      }
    }
  }
}
</style>
